export default __webpack_public_path__ + "static/media/maneuverwallofsteel.43e8ce87.png";